// extracted by mini-css-extract-plugin
export default {"link-button":"link-button--gCMTSy118SOOzfKIgqmd"};